import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { IconButton } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import NoData from '../../Components/Nodata';
import WarningDialog from '../../Components/WarningDialog';

import Images from '../../Utils/images';

import { ProductionListData } from '../../types';

import { removeContactsList } from '../../redux/StudioSlice';

interface Props {
  data: any;
}

export default function ContactsTable({ data }: Props) {
  // console.log(data, 'data')
  const limit = 6;
  const { t } = useTranslation('translation', {
    keyPrefix: 'Product_Management',
  });
  const { t: tC } = useTranslation('translation', {
    keyPrefix: 'Common',
  });

  const columns = [
    'Profile Image',
    'Full Name',
    'Department',
    'Permission',
    'Job Title',
    // 'Role Name',
    // 'Action',
  ];

  const handleContactRemove = (index: number) => {
    const contactsClone = [...data];

    contactsClone.splice(index, 1);

    // console.log('FFFF =>', contactsClone)
    removeContactsList(contactsClone);
  };

  console.log(data, 'datadatadatadatadata');
  // ${!showPagination && 'product_services_no_page'}
  // ${no_data && 'product_services_no_data'}
  return (
    <div className="reelTableContainer">
      <TableContainer component={Paper} elevation={0} className={`reelTable `}>
        <Table sx={{ minWidth: 650 }} aria-label="table" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column: string) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
              {/* <TableCell align="right">Role Name</TableCell> */}
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* <Loading type="table" tableColumns={11} /> */}

            {data?.map((item: ProductionListData, i: number) => (
              <TableRow
                key={item._id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                {/* Render each cell for the production record */}
                <TableCell component="td">
                  <img
                    className="table-dp"
                    src={item?.profilePicture || Images.Image_Placegolder}
                    alt=""
                  />
                </TableCell>
                <TableCell sx={{ textTransform: 'capitalize' }}>
                  {`${item?.firstName} ${item?.lastName}`}
                </TableCell>
                <TableCell>{item?.departmentName || '-'}</TableCell>

                {/* <TableCell>
                  {`${item?.accessLevel}, ${item?.permissionType}` || '-'}
                </TableCell> */}
                <TableCell>{item?.baseRole || '-'}</TableCell>
                <TableCell>{item?.roleName}</TableCell>

                <TableCell align="center">
                  <div className="tableActions">
                    <IconButton
                      className="btn_delete"
                      onClick={() => handleContactRemove(i)}
                    >
                      <img src={Images.TRASH} alt="Edit" />
                    </IconButton>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {!data?.length && <NoData heading={''} title={''} buttonText={''} />}
      </TableContainer>

      {/* {!!productionDataSelector?.productions?.length && (
        <TablePagination
          listData={productionDataSelector as ProductionListApiData}
          setPageChange={setCurrentPage}
        />
      )} */}

      <WarningDialog
        confirmBtnText={tC('btnTxt.Confirm')}
        cancelBtnText={tC('btnTxt.cancel')}
        open={false}
        handleClose={() => {}}
        type={'delete'}
        onClick={() => {}}
        title={''}
        description={''}
      />
    </div>
  );
}
